import type { HandoverData } from '@/shared/types'

type Brief = Pick<HandoverData, 'opportunity' | 'pitchAngle' | 'timing' | 'reasoning'>

const written = (t: string | null | undefined) => !!t?.trim()

/** Whether the AI wrote any of the brief. A verdict can arrive with all four
 *  texts empty, and the card then says "Ingen AI-sammanfattning ännu" rather
 *  than a "Genererad" header over empty sections (YCRM-59). */
export function hasAiBrief(h: Brief): boolean {
  return [h.opportunity, h.pitchAngle, h.timing, h.reasoning].some(written)
}

/** Whether the AI wrote its reasoning. Without it the card drops the whole
 *  AI-RESONEMANG section instead of showing the heading alone (YCRM-88). */
export function hasAiReasoning(h: Pick<Brief, 'reasoning'>): boolean {
  return written(h.reasoning)
}
